import React from "react";
import { Helmet } from "react-helmet-async";

// Configuration globale du site
const siteConfig = {
  siteName: "Estatia SCI",
  baseUrl: "https://estatia-sci.netlify.app", // URL correcte du site
  phone: "+237698476609",
  email: "estatiasci@gmail.com",
  socialMedia: {
    facebook: "",
    whatsapp: "https://wa.me/237698476609",
    tiktok: "https://www.tiktok.com/@estatiasci?_t=ZS-8u5ROFr1Zq6&_r=1",
    instagram: "",
    youtube: "",
    twitter: "",
    telegram: "https://t.me/+mEEGbI-6v91mMjY0",
  },
};

// Schéma global pour le site web
const globalSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: siteConfig.siteName,
  url: siteConfig.baseUrl,
  potentialAction: {
    "@type": "SearchAction",
    target: `${siteConfig.baseUrl}search?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

// Schéma pour l'organisation
const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: siteConfig.siteName,
  url: siteConfig.baseUrl,
  logo: `${siteConfig.baseUrl}logonotextwhite.png`, // Correction du chemin du logo
  sameAs: Object.values(siteConfig.socialMedia).filter((link) => link !== ""), // Filtrer les liens vides
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: siteConfig.phone,
      email: siteConfig.email,
      contactType: "customer service",
      areaServed: "CM",
      availableLanguage: ["French", "English"],
    },
  ],
};

// Détails des pages
const pageDetails = {
  "/": {
    title:
      "Estatia SCI | Immobilier, Informatique, Événementiel et Télécom au Cameroun",
    description:
      "Estatia SCI, votre partenaire de confiance en solutions immobilières, informatiques, événementielles et télécom au Cameroun. Expertise en gestion immobilière, développement web et mobile, et organisation d’événements.",
    keywords:
      "Estatia SCI, immobilier, informatique, événementiel, télécom, développement web, applications mobiles, gestion immobilière",
    schema: {
      "@type": "WebPage",
      name: "Accueil - Estatia SCI",
      description:
        "Page d'accueil de Estatia SCI, expert en immobilier, informatique, événementiel et télécom au Cameroun",
    },
  },
  "/acceuil": {
    title: "Accueil | Estatia SCI - Immobilier, Informatique et Événementiel",
    description:
      "Bienvenue sur Estatia SCI, votre expert en gestion immobilière, développement web, solutions mobiles et services événementiels au Cameroun.",
    keywords:
      "Estatia SCI, accueil, immobilier, développement web, événementiel, télécom",
    schema: {
      "@type": "WebPage",
      name: "Accueil - Estatia SCI",
      description:
        "Page d'accueil de Estatia SCI, expert en solutions diversifiées au Cameroun",
    },
  },
  "/contact": {
    title: "Contact | Estatia SCI - Parlons de Votre Projet",
    description:
      "Contactez Estatia SCI pour vos besoins en immobilier, développement web, événementiel et télécom au Cameroun. Nous sommes à votre écoute.",
    keywords:
      "contact, Estatia SCI, projet, devis, immobilier, informatique, événementiel",
    schema: {
      "@type": "ContactPage",
      name: "Contact - Estatia SCI",
      description:
        "Page de contact de Estatia SCI, expert en solutions innovantes au Cameroun",
    },
  },
  "/services": {
    title: "Nos Services | Estatia SCI",
    description:
      "Découvrez nos services : gestion immobilière, développement web et mobile, organisation d’événements et solutions télécom.",
    keywords:
      "services, immobilier, développement web, applications mobiles, événementiel, télécom",
    schema: {
      "@type": "Service",
      name: "Services - Estatia SCI",
      provider: {
        "@type": "Organization",
        name: "Estatia SCI",
      },
      description:
        "Services professionnels en immobilier, informatique, événementiel et télécom",
    },
  },
  "/apropos": {
    title: "À Propos | Estatia SCI",
    description:
      "Découvrez l’histoire, la mission et les valeurs d’Estatia SCI, expert en immobilier, informatique, événementiel et télécom au Cameroun.",
    keywords: "à propos, Estatia SCI, mission, valeurs, entreprise, vision",
    schema: {
      "@type": "AboutPage",
      name: "À Propos de Estatia SCI",
      description: "Présentation d'Estatia SCI et de son expertise diversifiée",
    },
  },
  "/vision/immobilier": {
    title: "Vision Immobilier | Estatia SCI",
    description:
      "Notre vision pour le secteur immobilier : gestion et promotion de biens, investissements et accompagnement sur mesure.",
    keywords:
      "immobilier, Estatia SCI, gestion immobilière, investissement, promotion",
    schema: {
      "@type": "Service",
      name: "Vision Immobilier - Estatia SCI",
      description:
        "Notre engagement pour un secteur immobilier dynamique et innovant",
    },
  },
  "/vision/informatique": {
    title: "Vision Informatique | Estatia SCI",
    description:
      "Nos solutions informatiques : développement web et mobile, cybersécurité, et transformation digitale.",
    keywords:
      "informatique, Estatia SCI, développement web, mobile, cybersécurité, transformation digitale",
    schema: {
      "@type": "Service",
      name: "Vision Informatique - Estatia SCI",
      description: "Solutions numériques pour un monde connecté et sécurisé",
    },
  },
  "/vision/évènementiel": {
    title: "Vision Événementiel | Estatia SCI",
    description:
      "Organisation d’événements professionnels et privés, gestion de séminaires, conférences et spectacles.",
    keywords:
      "événementiel, Estatia SCI, organisation d’événements, séminaires, conférences",
    schema: {
      "@type": "Service",
      name: "Vision Événementiel - Estatia SCI",
      description: "Des événements sur mesure pour tous vos besoins",
    },
  },
  "/vision/telecom": {
    title: "Vision Télécom | Estatia SCI",
    description:
      "Solutions télécom pour entreprises : installation, maintenance et services de communication avancés.",
    keywords:
      "télécom, Estatia SCI, communication, installation, maintenance, réseaux",
    schema: {
      "@type": "Service",
      name: "Vision Télécom - Estatia SCI",
      description: "Des infrastructures télécom performantes et adaptées",
    },
  },
  "/vision/mobile": {
    title: "Vision Mobile | Estatia SCI",
    description:
      "Développement d’applications mobiles sur mesure pour Android et iOS, UX/UI optimisé.",
    keywords: "mobile, Estatia SCI, applications mobiles, Android, iOS, UX/UI",
    schema: {
      "@type": "Service",
      name: "Vision Mobile - Estatia SCI",
      description: "Des applications mobiles modernes et performantes",
    },
  },
  "/vision/web": {
    title: "Vision Web | Estatia SCI",
    description:
      "Développement web sur mesure : sites vitrines, e-commerce, applications web interactives.",
    keywords:
      "web, Estatia SCI, développement web, sites vitrines, e-commerce, applications web",
    schema: {
      "@type": "Service",
      name: "Vision Web - Estatia SCI",
      description:
        "Solutions web innovantes pour une présence digitale efficace",
    },
  },
};

const SEOHelmet = ({ page }) => {
  const details = pageDetails[page] || pageDetails["/"];
  const currentUrl = `${siteConfig.baseUrl}${page}`;
  
  return (
    <>
      <Helmet>
        {/* Balises meta de base */}
        <html lang="fr" />
        <title>{details.title}</title>
        <meta name="description" content={details.description} />
        <meta name="keywords" content={details.keywords} />
        <meta name="author" content={siteConfig.siteName} />
        <meta name="robots" content="index, follow" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta charSet="UTF-8" />

        {/* Balise canonique */}
        <link rel="canonical" href={currentUrl} />

        {/* Favicon (logo sur l'onglet) */}
        <link
          rel="icon"
          type="image/png"
          href={`${siteConfig.baseUrl}logonotextwhite.png`}
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:title" content={details.title} />
        <meta property="og:description" content={details.description} />
        <meta
          property="og:image"
          content={`${siteConfig.baseUrl}logonotextwhite.png`}
        />
        <meta property="og:site_name" content={siteConfig.siteName} />
        <meta property="og:locale" content="fr_FR" />

        {/* Twitter Cards */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={details.title} />
        <meta name="twitter:description" content={details.description} />
        <meta
          name="twitter:image"
          content={`${siteConfig.baseUrl}logonotextwhite.png`}
        />

        {/* Métadonnées locales */}
        <meta name="geo.region" content="CM" />
        <meta name="geo.placename" content="Cameroun" />
      </Helmet>

      {/* Schémas JSON-LD */}
      <script type="application/ld+json">{JSON.stringify(globalSchema)}</script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          ...details.schema,
          mainEntityOfPage: {
            "@type": "WebPage",
            "@id": currentUrl,
          },
        })}
      </script>
    </>
  );
};

export default SEOHelmet;
